import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class errorInterceptor implements HttpInterceptor {
    translate = inject(TranslateService);
    router = inject(Router);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((err: HttpErrorResponse) => {
                let errMsg = this.translate.instant('HTTP_ERRORS.DEFAULT');
                if (err.status === 401 && !req.url.includes('/login')) {
                    localStorage.clear();
                    this.router.navigateByUrl('/login');
                }

                let error = errMsg;
                switch (err.status) {
                    case 400:
                        error = this.translate.instant('HTTP_ERRORS.400');
                        break;
                    case 401:
                        error = this.translate.instant('HTTP_ERRORS.401');
                        break;
                    case 403:
                        error = this.translate.instant('HTTP_ERRORS.403');
                        break;
                    case 404:
                        error = this.translate.instant('HTTP_ERRORS.404');
                        break;
                    case 500:
                        error = this.translate.instant('HTTP_ERRORS.500');
                        break;
                    case 503:
                        error = this.translate.instant('HTTP_ERRORS.503');
                        break;
                    case 504:
                        error = this.translate.instant('HTTP_ERRORS.504');
                        break;
                    default:
                        error = errMsg;
                }

                return throwError(() => error);
            })
        );
    };
}